import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const getRfidByUser: UseCase<UserRepository, 'getRfidByUser'> = repository => {
  return async (groupUid, userId) => {
    return await repository.getRfidByUser(groupUid, userId)
  }
}
